import styled from 'styled-components';

export const ActionButtons = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  z-index: 10;
  visibility: hidden;
`;

export const ActionButton = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.15s;

  &:hover {
    background: rgba(0, 0, 0, 0.75);
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  aspect-ratio: 1 / 1;
  flex-shrink: 0;
  background-color: white;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &:hover ${ActionButtons} {
    visibility: visible;
  }
`;
